//This file is automatically rebuilt by the Cesium build process.
export default "struct czm_materialInput\n\
{\n\
float s;\n\
vec2 st;\n\
vec3 str;\n\
vec3 normalEC;\n\
mat3 tangentToEyeMatrix;\n\
vec3 positionToEyeEC;\n\
float height;\n\
float slope;\n\
float aspect;\n\
};\n\
";
